import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ITowersTraconsImport } from './towers-tracons-import';


import { HttpHelper } from '../../shared/http-helper';

import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

@Injectable()
export class TowersTraconsImportService {

    //need to have this somewhere besides hardcoded in here
    //private _towersImportUrl = `http://localhost:55706/api/systemmanagement/TowersImport`;
    private _towersImportUrl = `api/systemmanagement/TowersImport`;
 
    constructor(private httpHelper: HttpHelper) { }

    getTowersImport(): Observable<ITowersTraconsImport> {
         return this.httpHelper.get(`${this._towersImportUrl}`)
             //.map((response: Response) => <ITowersTraconsImport> response.json())
             //.do(data => console.log('Towers Import service: ' +  JSON.stringify(data)))
             //.catch(this.handleError);
    }

   
    private handleError(error: Response) {
         // in a real world app, we may send the server to some remote logging infrastructure
         // instead of just logging it to the console
                 
         console.error(error);
         return Observable.throw(error.json().error || 'Server error');
    }
}


/** WEBPACK FOOTER **
 ** ./app/system-management/towers-tracons-import/towers-tracons-import.service.ts
 **/